import styled from "styled-components";

export const Container = styled.div`
  width: 100%;
  height: 100vh;
  display: flex;
  align-items: center;
  justify-content: center;
  /* flex-direction: column; */
  /* background-color: #242424; */

  .olho {
    position: absolute;
    width: 20px;
    top: 53%;
    right: 5%;
    z-index: 2;
    opacity: 0.6;
    cursor: pointer;
  }

  #password,
  #acesso,
  #acessoFooter,
  #passwordFooter,
  #aguarde,
  #aguardeFooter,
  #aguardesenha {
    display: none;
  }
`;

export const DivVerificaSenha = styled.div`
    display: none;
    background: #FFF;
    text-align: left;
    width: fit-content !important;
    border-radius: 6px;
    padding: 10px;
    font-size: 12px;
    div {
      display: flex;
      align-items: center;
      margin-bottom: 5px;
      padding-bottom: 5px;
      border-bottom: 1px solid #ebebeb;
      :last-child {
        border-bottom: none;
        margin-bottom: 0px;
        padding-bottom: 0px;
      }
      svg {
        margin-right: 5px;
      }
    }
    .scs { color: #479652; }
    .dng { color: #c82c09; }
`;

export const LogoApp = styled.div`
  width: 100%;
  max-width: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  img {
    width: 100%;
    height: auto;
  }
`;

export const ContainerApp = styled.div`
.container {
            max-width: 1200px;
            margin: 0 auto;
            padding: 20px;
            display: flex;
            flex-direction: column;
            align-items: center;
            min-height: 100vh;
    justify-content: center;
        }
        
        .logo {
            margin: 30px 0;
            text-align: center;
        }
        
        .logo img {
            max-width: 200px;
            height: auto;
        }
        
        .content {
            display: flex;
            flex-wrap: wrap;
            justify-content: center;
            align-items: center;
            gap: 50px;
            margin-top: 20px;
        }
        
        .phone-image {
            flex: 1;
            min-width: 300px;
            text-align: center;
        }
        
        .phone-image img {
            max-width: 100%;
            height: auto;
            max-height: 500px;
        }
        
        .download-info {
            flex: 1;
            min-width: 300px;
            text-align: center;
        }
        
        h1 {
            font-size: 2.5rem;
            margin-bottom: 20px;
            color: #2c3e50;
        }
        
        p {
            font-size: 1.1rem;
            margin-bottom: 30px;
            color: #7f8c8d;
        }
        
        .download-buttons {
            display: flex;
            justify-content: center;
            gap: 20px;
            flex-wrap: wrap;
        }
        
        .download-btn {
            display: inline-block;
            width: 180px;
            transition: transform 0.3s;
        }
        
        .download-btn:hover {
            transform: scale(1.05);
        }
        
        .download-btn img {
            width: 100%;
            height: auto;
        }
        
        footer {
            margin-top: auto;
            padding: 20px;
            text-align: center;
            color: #95a5a6;
            font-size: 0.9rem;
        }
        
        @media (max-width: 768px) {
            .content {
                flex-direction: column;
                gap: 30px;
            }
            
            h1 {
                font-size: 2rem;
            }
            
            .download-buttons {
                flex-direction: column;
                align-items: center;
            }
          .phone-image img {
              max-width: 200px;
              height: auto;
          }
        }
`;